import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDAccordion, FDAccordionDetails, FDAccordionTitle, FDBodyText, FDBox, FDLozenge, FDStack,
} from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import useMobileLayout from 'Hooks/useMobileLayout';
import useResource from 'Hooks/useResource';
import { LightPaper } from 'Views/Page/Content/Templates/TaxDiagnosticQuestionStepTemplate/LightPaper';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxDiagnosticQuestion,
} from './TaxDiagnosticQuestion';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .done();

export const TaxDiagnosticSummaryAccordion = ({ section }) => {
  const {
    resource,
  } = useResource(section);
  const isMobile = useMobileLayout();
  const [expanded, setExpanded] = useState(false);

  return (
    <FDAccordion expanded={expanded} onChange={() => setExpanded(!expanded)} flex={1}>
      <FDAccordionTitle>
        <FDStack
          alignItems={'center'}
          spacing={1}
          width={'100%'}
          justifyContent="center"
          {...dataAttrs('summary-title', resource)}
        >
          <FDBox flex={1}>
            <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'title'} flex={1} />
          </FDBox>
          {resource.attr('lozengeLabel') && <FDLozenge color={resource.attr('lozengeStatus') || 'info'} label={resource.attr('lozengeLabel')} {...dataAttrs('question-lozenge')} />}
        </FDStack>
      </FDAccordionTitle>
      <FDAccordionDetails>
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={2}>
          <FDBox flex={1}>
            <LightPaper padding={2}>
              <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'description'} fullWidth />
            </LightPaper>
          </FDBox>
          <FDBox flex={1} {...dataAttrs('summary-question-section', resource)}>
            {resource.attr('questions')?.resources().list().map((q) => (<TaxDiagnosticQuestion key={q.id()} resource={q} />))}
          </FDBox>
        </FDStack>
      </FDAccordionDetails>
    </FDAccordion>
  );
};

TaxDiagnosticSummaryAccordion.propTypes = {
  section: PropTypes.instanceOf(fr.Resource).isRequired,
};
